{
  "basicTerms": {
    "selectedOfTotal": "已選取 {selected}/{total}",
    "search": "搜尋",
    "summary": "摘要",
    "insights": "洞察分析",
    "help": "說明",
    "expand": "展開",
    "collapse": "收合",
    "menu": "選單",
    "account": "帳戶",
    "logout": "登出",
    "signIn": "登入",
    "days": "天 | 天",
    "phone": "電話",
    "subscribers": "訂閱者 | 訂閱者",
    "favorites": "最愛 | 最愛",
    "others": "其他 | 其他",
    "yes": "是",
    "no": "否",
    "locations": "地點 | 地點",
    "active": "啟用中",
    "inactive": "未啟用",
    "all": "全部",
    "view": "檢視",
    "language": "語言",
    "required": "必填",
    "timezone": "時區",
    "new": "新增",
    "open": "開放",
    "close": "關閉",
    "closed": "已關閉",
    "occupied": "已占用",
    "reserved": "已保留",
    "enabled": "已啟用",
    "disabled": "已停用",
    "enable": "啟用",
    "disable": "停用",
    "print": "列印",
    "download": "下載",
    "zoomIn": "放大",
    "zoomOut": "縮小",
    "previous": "上一步",
    "next": "下一步",
    "version": "版本",
    "setup": "設定",
    "caution": "注意",
    "notes": "備註 | 備註",
    "add": "新增",
    "remove": "移除",
    "duration": "時長",
    "link": "連結",
    "unlink": "取消連結",
    "to": "至",
    "success": "成功",
    "error": "錯誤",
    "info": "資訊",
    "warning": "警告",
    "time": "時間",
    "saved": "已儲存",
    "forms": "表單 | 表單",
    "is": "為",
    "only": "僅",
    "saving": "正在儲存",
    "text": "文字",
    "zip": "zip",
    "spreadsheet": "試算表",
    "image": "圖片",
    "cloning": "正在複製",
    "clone": "複製",
    "added": "已新增",
    "removed": "已移除",
    "planned": "已排定",
    "unplanned": "未排定",
    "checkedIn": "已報到",
    "checkedOut": "已離場",
    "more": "更多",
    "okay": "確定",
    "reschedule": "重新安排",
    "results": "結果 | 結果",
    "none": "無",
    "pages": "頁 | 頁",
    "pageOfTotal": "第 {current} 頁，共 {total} 頁",
    "of": "/",
    "default": "預設",
    "soon": "即將推出",
    "grid": "格狀",
    "list": "清單",
    "booked": "已預約",
    "arrivals": "抵達 | 抵達",
    "early": "提早",
    "late": "遲到",
    "onTime": "準時",
    "area": "區域 | 區域",
    "spot": "車位",
    "single": "單一",
    "multiple": "多個",
    "filter": "篩選",
    "board": "看板",
    "at": "於",
    "from": "從",
    "recent": "最近",
    "delivered": "已送達",
    "sent": "已傳送",
    "failed": "失敗",
    "create": "建立",
    "tasks": "任務 | 任務",
    "emails": "電子郵件 | 電子郵件",
    "passwords": "密碼 | 密碼",
    "limits": "限制",
    "assignee": "負責人",
    "comment": "留言",
    "issue": "問題",
    "urgent": "緊急",
    "retry": "重試",
    "custom": "自訂",
    "na": "不適用"
  },
  "phrases": {
    "updateEmail": "更新電子郵件",
    "copyToClipboard": "複製到剪貼簿",
    "copiedToClipboard": "已複製到剪貼簿",
    "warehouseAddress": "倉庫地址",
    "cloneSchedule": "複製時間表",
    "open24Hours": "24 小時營業",
    "featureEnabled": "功能已啟用",
    "featureDisabled": "功能已停用",
    "learnMore": "瞭解詳情",
    "minuteLabel": "{minutes} 分鐘",
    "minuteLabelFull": "{minutes} 分鐘",
    "thisActionCannotBeUndone": "此動作「無法」復原",
    "areYouSure": "您確定嗎？",
    "unknownUser": "未知使用者",
    "leaveWithoutSaving": "不儲存並離開",
    "learnHowItWorks": "瞭解運作方式",
    "allFields": "所有欄位",
    "selectColumns": "選擇欄位",
    "selectedColumns": "已選取的欄位",
    "addFiles": "新增檔案 | 新增檔案",
    "tasks": "沒有任務 | {count} 個任務 | {count} 個任務",
    "driversSelfCheckin": "司機自助報到",
    "addReferenceNumber": "新增參考編號",
    "myAccount": "我的帳戶"
  },
  "messages": {
    "theConfirmationFieldDoesNotSupportPasting": "確認欄位不支援貼上",
    "youMayHaveUnsavedChangesAreYouSureYouWantToLeaveThisPage": "您可能有尚未儲存的變更，確定要離開此頁面嗎？",
    "browserDoesNotSupportCopyFunction": "瀏覽器不支援複製功能",
    "permissionToAccessClipboardWasDeniedToEnableAccessUpdateYourBrowserSettings": "存取剪貼簿的權限遭拒。如要啟用存取，請更新您的瀏覽器設定。",
    "alternativelyYouCanManuallyCopy": "您也可以手動複製",
    "areYouSureYouWantToLeaveYouMayHaveUnsavedChanges": "確定要離開嗎？您可能有尚未儲存的變更。",
    "noResultsFound": "找不到結果",
    "maximumOfReferenceNumbersAllowedCountRemoved": "最多允許 {maxItems} 個參考編號。已移除 {removedCount} 個"
  },
  "fileFormats": {
    "jpeg": "jpeg",
    "jpg": "jpg",
    "png": "png",
    "webp": "webp",
    "pdf": "pdf"
  },
  "specialtyTerms": {
    "opendock": "Opendock",
    "warehouses": "倉庫 | 倉庫",
    "carrierContacts": "承運商聯絡人 | 承運商聯絡人",
    "loadTypes": "貨物類型 | 貨物類型",
    "docks": "月台 | 月台",
    "appointments": "預約 | 預約",
    "users": "使用者 | 使用者",
    "organizations": "組織 | 組織",
    "orgs": "組織 | 組織",
    "companies": "公司 | 公司",
    "referenceNumber": "參考編號",
    "refNumber": "參考編號",
    "status": "狀態",
    "orgLoadTypes": "組織貨物類型",
    "schedulingPortal": "預約入口網站",
    "customFields": "自訂欄位 | 自訂欄位",
    "interval": "間隔",
    "drivers": "司機 | 司機",
    "carriers": "承運商 | 承運商",
    "tags": "標籤 | 標籤",
    "yardManagement": "場站管理",
    "carrier": "承運商 | 承運商",
    "assets": "資產 | 資產",
    "tvMode": "電視模式",
    "gridView": "格狀檢視",
    "listView": "清單檢視",
    "gateManagement": "門禁管理",
    "selfCheckIn": "自助報到",
    "gateFeed": "門禁動態"
  },
  "appointmentStatuses": {
    "NoShow": "未到",
    "Cancelled": "已取消",
    "Requested": "已申請",
    "Scheduled": "已排定",
    "Arrived": "已抵達",
    "InProgress": "作業中",
    "Completed": "已完成",
    "Reserves": "保留時段"
  },
  "appointmentTypes": {
    "standard": "標準",
    "reserved": "已保留",
    "reserve": "保留"
  },
  "appointmentCreatorTypes": {
    "warehouseUser": "倉庫使用者",
    "carrier": "承運商"
  },
  "roles": {
    "base": "基本",
    "carrier": "承運商",
    "carrierAdmin": "承運商管理員",
    "spectator": "檢視者",
    "attendant": "值班人員",
    "operator": "操作員",
    "admin": "管理員",
    "owner": "擁有者",
    "internal": "內部",
    "god": "最高權限"
  },
  "weekdays": {
    "sunday": "星期日",
    "monday": "星期一",
    "tuesday": "星期二",
    "wednesday": "星期三",
    "thursday": "星期四",
    "friday": "星期五",
    "saturday": "星期六"
  },
  "weekdaysAbbr": {
    "sun": "週日",
    "mon": "週一",
    "tue": "週二",
    "wed": "週三",
    "thu": "週四",
    "fri": "週五",
    "sat": "週六"
  },
  "buttons": {
    "nevermind": "算了",
    "select": "選擇",
    "confirm": "確認",
    "next": "下一步",
    "previous": "上一步",
    "create": "建立",
    "edit": "編輯",
    "save": "儲存",
    "send": "傳送",
    "yesDelete": "是，刪除",
    "skipCreation": "略過建立",
    "cancel": "取消",
    "export": "匯出",
    "saveChanges": "儲存變更",
    "exportData": "匯出資料",
    "resetToDefault": "重設為預設值"
  },
  "tooltips": {
    "notAvailable": "無法使用",
    "notAvailableForUserRole": "您的使用者角色無法使用此功能。"
  },
  "errors": {
    "unkownError": "發生未知錯誤。",
    "thisFieldIsRequired": "此欄位為必填",
    "passwordDoesNotMeetRequirements": "密碼不符合密碼要求",
    "emailMustBeValid": "電子郵件必須有效",
    "pleaseEnterAValidPhoneNumber": "請輸入有效的電話號碼",
    "pleaseEnterAValidUrl": "請輸入有效的網址",
    "invalidHour": "小時無效",
    "invalidMinute": "分鐘無效",
    "pleaseSelectAmOrPm": "請選擇上午或下午",
    "pleaseEnterACompleteDateAndTime": "請輸入完整的日期和時間",
    "mustBeANumber": "必須為數字",
    "mustBeAPositiveInteger": "必須為正整數",
    "mustBeAWholeNumber": "必須為整數",
    "isNotAValidNumber": "不是有效的數字",
    "isNotValid": "無效",
    "invalidUuid": "UUID 無效",
    "dateMustNotBeInThePast": "日期不得早於今天",
    "mustBeWithin24HoursOfStartTime": "必須在開始時間的 24 小時內",
    "pleaseSelectAtLeast": "請至少選擇 {requiredCount} 個{itemName} | 請至少選擇 {requiredCount} 個{itemName}",
    "cannotSelectMoreThan": "最多只能選擇 {limit} 個{itemName} | 最多只能選擇 {limit} 個{itemName}",
    "fieldMustEqual": "欄位必須等於 {value}",
    "mustBeXCharacters": "必須為 {length} 個字元 | 必須為 {length} 個字元",
    "mustBeAtLeastXCharacters": "長度至少須為 {min} 個字元 | 長度至少須為 {min} 個字元",
    "mustBeAtMostXCharacters": "長度最多為 {max} 個字元 | 長度最多為 {max} 個字元",
    "mustBeBetweenXAndYCharactersLong": "長度必須介於 {min} 到 {max} 個字元之間",
    "mustBeNumberBetweenXAndY": "必須為介於 {min} 到 {max} 之間的數字",
    "mustBeNumberGreaterThan": "必須為大於或等於 {min} 的數字",
    "mustBeNumberLessThan": "必須為小於 {max} 的數字",
    "mustHaveAtLeast8Characters": "至少須有 8 個字元",
    "mustContainUpperCaseAndLowerCase": "必須包含大寫與小寫字母",
    "mustContainAtLeastOneLetter": "必須包含至少一個字母",
    "mustContainAtLeastOneSpecialCharacter": "必須包含至少一個特殊字元",
    "mustContainAtLeastOneNumber": "必須包含至少一個數字",
    "atLeastOneReferenceNumberIsRequired": "至少需要一個{refNumberDisplayName}",
    "mustBeAValidNumber": "必須為有效的數字"
  },
  "warehouseAmenities": {
    "lumperServices": "卸貨工服務",
    "overnightParking": "過夜停車",
    "driversRestroom": "司機洗手間",
    "freeWiFi": "免費 Wi-Fi"
  },
  "warehousePPERequirements": {
    "safetyBoots": "安全鞋",
    "safetyGlasses": "護目鏡",
    "gloves": "手套",
    "hardHat": "安全帽",
    "faceMask": "口罩",
    "noSmoking": "禁止吸菸",
    "longPants": "長褲",
    "longSleeves": "長袖",
    "highVisibilityVest": "反光背心",
    "hairAndBeardNet": "髮網與鬍鬚網"
  },
  "auditLog": {
    "header": "稽核記錄",
    "viewAuditLog": "檢視稽核記錄",
    "noAuditLogEvents": "沒有稽核記錄事件",
    "printedOn": "列印於 {date}",
    "viewDetails": "檢視詳細資料",
    "snapshot": {
      "schedule": "排程",
      "eta": "預計到達時間",
      "emailSubscribers": "電子郵件訂閱者",
      "customFields": "自訂欄位",
      "statusTimes": "狀態時間"
    },
    "timelineForAllUpdatesMadeToThis": "此項目所有更新的時間軸：",
    "hasTheWords": "包含字詞",
    "eventsFromDate": "事件起始日期",
    "searchEvents": "搜尋事件",
    "by": "由",
    "appointmentUpdatesTimeline": "預約更新時間軸：",
    "moreUpdates": "還有 {count} 筆更新",
    "emailSubscribersUpdated": "已更新電子郵件訂閱者",
    "detailsUpdated": "已更新詳細資料",
    "recurrenceCreated": "已建立週期性預約",
    "recurrenceDeleted": "已刪除週期性預約",
    "rescheduled": "{label}已重新安排",
    "etaUpdated": "已更新預計抵達時間",
    "emailNotifications": "電子郵件通知",
    "carrierContactUpdated": "已更新承運商聯絡人",
    "reserveTransferred": "已轉移保留時段",
    "tagsUpdated": "已更新標籤",
    "scheduled": "{label}已排定",
    "statusUpdated": "已更新狀態",
    "timeUpdated": "已更新{arrived}時間",
    "dwellTimeUpdated": "已更新停留時間",
    "labelWithStatus": "{label} {status}",
    "arrivedLate": "延遲 {duration}",
    "everyXAtXUntilX": "每{weekDays} {'@'} {endTime}，直到 {endDate}",
    "opendockTeam": "Opendock 團隊",
    "unknownUser": "未知使用者",
    "deleted": "已刪除",
    "hasBeenCleared": "已清除",
    "actionUpdated": "已更新",
    "actionCreated": "已建立",
    "actionDeleted": "已刪除",
    "noAction": "無動作",
    "emptyValue": "空值"
  },
  "timeline": {
    "createdTheTask": "建立了任務",
    "startedTheTask": "開始了任務",
    "blockedTheTask": "封鎖了任務",
    "unblockedTheTask": "解除封鎖了任務",
    "completedTheTask": "完成了任務",
    "cancelledTheTask": "取消了任務",
    "cancelledTheReserve": "取消了保留",
    "cancelledTheReservationForSpot": "取消了此任務對 {areaName} - {spotCode} 的保留",
    "reservedSpotForThisTask": "為此任務保留了 {areaName} - {spotCode}",
    "reservedTheSpot": "保留了車位",
    "reason": "原因：{reason}",
    "addedA": "新增了",
    "reportedAn": "回報了",
    "clearedThe": "清除了",
    "flaggedTheTask": "標記了任務",
    "flaggedTheTaskAs": "將任務標記為",
    "unflaggedTheTask": "取消標記了任務",
    "unflaggedTheTaskAs": "取消了任務的標記：",
    "updatedTheTask": "更新了任務",
    "removedTask": "移除了任務",
    "attachments": "附件",
    "confirmedTheLocation": "確認了位置",
    "reportedAsMissing": "回報為遺失",
    "noActivityYet": "尚無活動",
    "noAssignee": "無負責人",
    "failedToFetchYardTaskTimeline": "無法取得場站任務時間軸",
    "failedToCreateComment": "無法建立留言"
  },
  "yardSpotStatusDialog": {
    "headers": {
      "actionThisSpot": "要{action}此車位嗎？"
    },
    "dropDownItems": {
      "cleaning": "清潔中",
      "underMaintenance": "維修中",
      "blockedByEquipment": "被設備阻擋",
      "safetyInspection": "安全檢查",
      "routineInspection": "例行檢查",
      "reserved": "已保留",
      "repairsNeeded": "需要維修",
      "damage": "損壞"
    },
    "labels": {
      "reason": "原因",
      "additionalNotes": "其他備註"
    },
    "placeholders": {
      "selectAReason": "選擇原因",
      "enterAdditionalNotes": "輸入其他備註"
    },
    "messages": {
      "thisSpotWillRemainUnavailable": "在重新設為開放之前，此車位將無法用於指派資產。",
      "thisDoorWillBeSetAsOpen": "此門將設為開放，並可再次用於指派資產。",
      "assetInTransitClosingWillBlockMove": "資產 {assetCode} 目前正在移往此車位。關閉此車位將導致該移動無法完成。"
    }
  },
  "tasks": {
    "presenter": {
      "unassigned": "未指派",
      "noDueDate": "無到期日",
      "fromAnySpot": "從任一車位",
      "toAnySpot": "至任一車位",
      "anyAsset": "任一資產",
      "types": {
        "move": "移動"
      },
      "status": {
        "toDo": "待辦",
        "inProgress": "進行中",
        "completed": "已完成",
        "canceled": "已取消"
      },
      "issue": "問題",
      "relatedEntity": {
        "spotArea": "區域",
        "spot": "車位",
        "asset": "資產"
      }
    }
  },
  "readyForPickupNotificationDialog": {
    "title": "可取貨通知",
    "messages": {
      "body": "傳送電子郵件給下列聯絡人，通知資產 {assetContainerCode} 已可在 {warehouseName} 取貨。",
      "notificationSent": "已成功傳送通知。",
      "notificationFailed": "傳送通知失敗，請再試一次。"
    },
    "labels": {
      "notifyTheseContacts": "通知以下聯絡人：",
      "suggestedContacts": "建議聯絡人："
    },
    "buttons": {
      "skipNotification": "略過通知"
    }
  },
  "chipList": {
    "keys": {
      "enter": "enter",
      "tab": "tab"
    },
    "messages": {
      "pressEnterOrTabToActionEntity": "按 {enterKey} 或 {tabKey} {action}{entity}",
      "pressEnterOrTabToAddEmail": "按 {enterKey} 或 {tabKey} 新增電子郵件"
    },
    "placeholders": {
      "emailSubscribers": "電子郵件訂閱者"
    }
  }
}
